import React, { useEffect } from 'react';

const PaymentSuccess = () => {
  useEffect(() => {
    // URL 파라미터에서 popup 플래그 확인
    const params = new URLSearchParams(window.location.search);
    const isPopup = params.get('popup') === 'true';
    const origin = params.get('origin') || window.location.origin;

    // 팝업 창에서 열렸는지 확인
    if (isPopup && window.opener) {
      // 팝업 창인 경우: 부모 창에 postMessage를 보내고 팝업 닫기
      try {
        window.opener.postMessage({
          type: 'NICEPAY_PAYMENT_SUCCESS'
        }, origin);
      } catch (e) {
        console.error('postMessage 전송 실패:', e);
      }
      // 팝업 닫기
      window.close();
      return;
    }

    // 일반 페이지인 경우: 기존 로직 유지 (하위 호환성)
    // 결제 완료 토스트 표시(리다이렉트 후 페이지에서 App이 소비)
    try {
      localStorage.setItem(
        'app_toast',
        JSON.stringify({ type: 'success', message: '결제가 완료되었습니다.', ts: Date.now() })
      );
    } catch (e) {
      // ignore
    }

    // 결제 직전 페이지로 복귀
    let redirect = null;
    try {
      redirect = localStorage.getItem('payment_redirect');
      if (redirect) localStorage.removeItem('payment_redirect');
    } catch (e) {
      redirect = null;
    }

    // 기본은 메인으로
    const target = redirect || '/';
    // 바로 이전 페이지로 복귀 (히스토리 쌓지 않도록 replace)
    window.location.replace(target);
  }, []);

  return (
    <div style={{ padding:'70px', textAlign:'center' }}>
      <h1 style={{ color:'#4461c0' }}>결제 완료</h1>
      <p style={{ fontSize:'1.26em', marginTop:'50px' }}>
        성공적으로 결제가 처리되었습니다!<br/>
        서비스 이용을 시작하실 수 있습니다.
      </p>
    </div>
  );
};

export default PaymentSuccess;
